import './buttons.scss';
import icon_template from './icon_button.html';
import text_template from './text_button.html';
import vfButton from './vf-button.vue';
import { SIZES } from 'design-assets/constants/sizes.js';

export const vfTextButton = {
    props: [ 'text' ],
    template: text_template,
    components: { vfButton },
};

export const vfIconButtonFactory = (icon) => ({
    props: {
        'text': {
            type: String,
        },
        'size': {
            type: String,
            default: 'vf-icon-medium',
        },
        'buttonSize': {
            default: SIZES.LARGE,
        },
    },
    template: icon_template,
    components: {
        vfButton,
        icon,
    },
});

export { default as vfButton } from './vf-button.vue';
export { default as vfLoaderButton } from './loader-button.vue';
